import React, { useEffect, useState } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import ShareIcon from "@mui/icons-material/Share";
import { Plane, ClipboardList, Building, Package, Weight } from "lucide-react";
import {
  TextField,
  Button,
  IconButton,
  Box,
  useMediaQuery,
} from "@mui/material";
// import toast from "react-hot-toast";
import { useParams, useSearchParams } from "react-router-dom";
import HistoryIcon from "@mui/icons-material/History";
import { styled } from "@mui/material/styles";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import { httpinstance } from "../../../axios/api";
import { updatenotificationdata } from "../../../store/Common/CommonSlice";
import { useDispatch } from "react-redux";
const defaultTheme = createTheme();

const HistoryTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#f5f5f9",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #dadde9",
  },
}));

const AwbTrackingPage = ({ type }) => {
  const dispatch = useDispatch();
  const isMobile = useMediaQuery("(max-width:600px)"); 
  const [searchparams] = useSearchParams();
  const params = searchparams.get("trackingId");
  const encodedAwbNumber  = useParams();
  const [milestones, setMilestones] = useState([]);
  const [isVertical, setIsVertical] = useState(false);
  const [trackList, setTrackList] = useState(null);
  const [publicUrl, setPublicUrl] = useState(null);
  const [showBox, setShowBox] = useState(false);
  const [status, setStatus] = useState();
  const [dialogIndex, setdialogIndex] = useState(null);
  const [tabularViewData, settabularViewData] = useState(null);

  // Fetch AWB tracked list and milestones
  useEffect(() => {
    awsTrackedList();
    async function awsTrackedList() {
      try {
        const response =  type === "public" ? 
        await httpinstance.get(
          `awb-tracked-list/track/${encodedAwbNumber?.encodedAwbNumber}`
        ):

         await httpinstance.get(
          `/awb-tracked-list/${params}`
        );
        if (response.data.success === "success") {
          setTrackList(response.data.data);
          setMilestones(response.data.data.events);
        }
      } catch (error) {
        
        const errorPaylpoad = {
            success: "error",
            statusCode : error?.response?.status,
            message: error?.response?.data?.errors?.[0]?.msg || error?.response?.data?.message || "Internal Server Error",
            error: error?.[0]?.error || {},
        }
        dispatch(updatenotificationdata(errorPaylpoad))
      }
    }
  }, [params]);
  //MOBILE RESPONSIVE VERTICAL TRACKING
  useEffect(() => {
    setIsVertical(isMobile);
  }, [isMobile]);

  const handleCopy = (event) => {
    navigator.clipboard.writeText(publicUrl);
    setShowBox(false);
  };

  const handleShareIconClick = async () => {
    // to call api to generate public url

    setShowBox(!showBox);
    try {
      const { data } = await httpinstance.get(
        `awb-tracked-list/generate-public-link/${params}`
      );
      setPublicUrl(data?.data?.publicUrl);
    } catch (error) {}
  };

  function calculateSum(elements) {
    let sum = 0;
    elements.forEach((element) => {
      sum += element?.pieces || 0;
    });
    return sum;
  }

  const handleHistoryOpen = async (
    index,
    milestone,
    flightNumber
  ) => {
    setdialogIndex(index);
  };

  const handleHistoryClose = () => {
    setdialogIndex(null);
  };

  return (
    <ThemeProvider theme={defaultTheme}>
      {
        type!="public" &&
        <div className="sharebox flex justify-end items-center mb-6">
        <h2 className="text-lg font-bold">Copy Link</h2>
        <figure className="relative  bg-yellow-500 w-[32px]  h-[32px] rounded-full ml-3 ">
          <IconButton
            onClick={handleShareIconClick}
            className="relative z-index-2"
          >
            <ShareIcon className=" iconshare text-white-500 " />
          </IconButton>

          <span className="absolute top-0 inline-flex h-full w-full animate-ping rounded-full left-0 bg-yellow-400 opacity-75"></span>
        </figure>
      </div>
      }
     

      <div className="whiteBox w-full rounded-2xl shadow-cardsection bg-white 2xl:p-5 xl:p-5 lg:p-5 md:p-5 sm:p-2">
        <Box component="form" noValidate autoComplete="off">
          <div className="flex flex-wrap   lg:flex  md:flex  sm:flex " >
           <div className="w-1/2 2xl:w-1/5 xl:w-1/5 lg:w-1/5 md:w-1/3 sm:w-1/2 sm:mb-3 mb-0 ">
              <div className="flex trackinglist">
                <figure className="bg-yellow-50 w-[35px] h-[35px] rounded-full  border border-yellow-200 p-1 flex justify-center item-center center">
                  <ClipboardList className="text-yellow-400" />
                </figure>
                <aside className="ml-4 ">
                  <TextField
                    id="awb-number"
                    label="AWB Number"
                    defaultValue={trackList?.awbNumber}
                    value={trackList?.awbNumber}
                    InputLabelProps={{ shrink: true }}
                    InputProps={{ readOnly: trackList?.awbNumber?true:true }}
                    slotProps={{ input: { readOnly: true } }}
                    fullWidth
                  />
                </aside>
              </div>{" "}
            </div>
            <div className="w-1/2 2xl:w-1/5 xl:w-1/5 lg:w-1/5 md:w-1/3 sm:w-1/2 sm:mb-3 mb-0 ">
              <div className="flex trackinglist">
                <figure className="bg-yellow-50 w-[35px] h-[35px] rounded-full  border border-yellow-200 p-1 flex justify-center item-center center">
                  <Building className="text-yellow-400" />
                </figure>
                <aside className="ml-4">
                  <TextField
                    id="destination"
                    label="Destination"
                    sx={
                      isMobile
                        ? {
                            boxShadow: "rgba(0, 0, 0, 0.20) 0px 3px 10px",
                            width: "90% !important",
                          }
                        : { boxShadow: "rgba(0, 0, 0, 0.20) 0px 3px 10px" }
                    }
                    defaultValue={trackList?.destination}
                    value={trackList?.destination}
                    InputLabelProps={{ shrink: true }}
                    slotProps={{ input: { readOnly: true } }}
                    InputProps={{ readOnly: trackList?.destination?true:true }}
                    fullWidth
                  />
                </aside>
              </div>{" "}
            </div>
            <div className="w-1/2 2xl:w-1/5 xl:w-1/5 lg:w-1/5 md:w-1/3 sm:w-1/2 sm:mb-3 mb-0 ">
              <div className="flex trackinglist">
                <figure className="bg-yellow-50 w-[35px] h-[35px] rounded-full  border border-yellow-200 p-1 flex justify-center item-center center">
                  <Plane className="text-yellow-400" />
                </figure>
                <aside className="ml-4">
                  <TextField
                    id="origin"
                    label="Origin"
                    sx={
                      isMobile
                        ? {
                            boxShadow: "rgba(0, 0, 0, 0.20) 0px 3px 10px",
                            width: "90% !important",
                          }
                        : { boxShadow: "rgba(0, 0, 0, 0.20) 0px 3px 10px" }
                    }
                    defaultValue={trackList?.origin}
                    value={trackList?.origin}
                    InputLabelProps={{ shrink: true }}
                    slotProps={{ input: { readOnly: true } }}
                    inputProps={{ readOnly: trackList?.origin?true:true }}
                    fullWidth
                  />
                </aside>
              </div>{" "}
            </div>
            <div className="w-1/2 2xl:w-1/5 xl:w-1/5 lg:w-1/5 md:w-1/3 sm:w-1/2 sm:mb-3 mb-0 ">
              <div className="flex trackinglist">
                <figure className="bg-yellow-50 w-[35px] h-[35px] rounded-full  border border-yellow-200 p-1 flex justify-center item-center center">
                  <Package className="text-yellow-400" />
                </figure>
                <aside className="ml-4">
                  <TextField
                    id="pieces"
                    label="Pkts"
                    sx={
                      isMobile
                        ? {
                            boxShadow: "rgba(0, 0, 0, 0.20) 0px 3px 10px",
                            width: "90% !important",
                          }
                        : { boxShadow: "rgba(0, 0, 0, 0.20) 0px 3px 10px" }
                    }
                    defaultValue={trackList?.pieces}
                    value={trackList?.pieces}
                    InputLabelProps={{ shrink: true }}
                    slotProps={{ input: { readOnly: true } }}
                    inputProps={{ readOnly: trackList?.pieces?true:true }}
                    fullWidth
                  />
                </aside>
              </div>{" "}
            </div>
            <div className="w-1/2 2xl:w-1/5 xl:w-1/5 lg:w-1/5 md:w-1/3 sm:w-1/2 sm:mb-3 mb-0 ">
              <div className="flex trackinglist">
                <figure className="bg-yellow-50 w-[35px] h-[35px] rounded-full  border border-yellow-200 p-1 flex justify-center item-center center">
                  <Weight className="text-yellow-400" />
                </figure>
                <aside className="ml-4 ">
                  <TextField
                    id="weight"
                    label="Weight"
                    sx={
                      isMobile
                        ? {
                            boxShadow: "rgba(0, 0, 0, 0.20) 0px 3px 10px",
                            width: "90% !important",
                          }
                        : { boxShadow: "rgba(0, 0, 0, 0.20) 0px 3px 10px" }
                    }
                    defaultValue={trackList?.weight}
                    value={trackList?.weight}
                    InputLabelProps={{ shrink: true }}
                    slotProps={{ input: { readOnly: true } }}
                    inputProps={{ readOnly: trackList?.weight?true:true }}
                    fullWidth
                  />
                </aside>
              </div>{" "}
            </div>{" "}
          </div>
        </Box>
      </div>
      {/* Milestone Tracker */}

      <div className="whiteBox  mt-5 mb-5">
        <>
        <div className=" w-full rounded-2xl shadow-cardsection bg-white xl:p-5 lg:p-5 md:p-5 sm:p-2">
          <div className="relative w-full xl:overflow-x-auto lg:overflow-x-auto md:overflow-x-auto sm:overflow-visible">
            <div className="RoadMap  ">
              <div className="relative mx-auto max-w-screen-lg px-0  2xl:p-1 xl:px-31 lg:px-1 md:px-1 sm:px-0">
                <div className="relative   flex-none 2xl:flex  xl:flex lg:flex md:flex  sm:flex-none  justify-between mt-[20px] mb-[20px] text-xs">
                  {Array.isArray(milestones) && milestones?.map((element, index) => (
                    <div
                      key={index}
                      className="relative roadinn flex flex-col items-center w-[337px] mb-5"
                    >
                      <div
                        className={`w-[20px] h-[20px] roadCircle rounded-full ${
                          element[0].milestone === "Delivered"
                            ? calculateSum(element) === trackList.pieces
                              ? "bg-green-500"
                              : "bg-yellow-500"
                            : element[0].status === 0
                            ? "bg-gray-500"
                            : (element[0].status === 1 &&
                                element[1]?.status === 1) ||
                              (element[0].status === 1 && element.length === 1)
                            ? "bg-green-500"
                            : element[0].status === 1 &&
                              element[1]?.status === 0
                            ? "bg-yellow-500"
                            : "bg-gray-500"
                        } absolute top-1/2 transform -translate-y-1/2`}
                      ></div>
                      <div
                        className={` roadLine ${
                          index === 0
                            ? "absolute left-[51%]"
                            : "absolute left-[-51%]"
                        } ${
                          milestones.length - 1 === index
                            ? "right-[50%]"
                            : milestones.length === 3
                            ? "right-[-55%]"
                            : milestones.length === 4
                            ? "right-[-50%]"
                            : "right-[-50%]"
                        } top-1/2 h-[4px] ${
                          element[0].milestone === "Delivered"
                            ? calculateSum(element) === trackList.pieces
                              ? "bg-green-500"
                              : element[0].status === 0
                              ? "bg-gray-500"
                              : "bg-yellow-500"
                            : (element[0].status === 1 &&
                                element[1]?.status === 1) ||
                              (element[0].status === 1 && element.length === 1)
                            ? "bg-green-500"
                            : element[0].status === 1 &&
                              element[1]?.status === 0
                            ? "bg-yellow-500"
                            : "bg-gray-500"
                        } z-[-1] transform translate-y-[-50%]`}
                      ></div>
                      {/* Description Box */}
                      <div
                        className={` RoadBox w-[190px] ${
                          index % 2 === 0 ? "mt-[245px]" : ""
                        } dark:border-white p-[5px]`}
                        style={{
                          boxShadow: "rgba(0, 0, 0, 0.20) 0px 3px 10px",
                        }}
                      >
                        {
                          <>
                            <div className="flex flex-col items-center">
                              <div className="boxx">
                                <div className="flex items-center justify-start relative">
                                  <p className="text-center">
                                    {element[0].milestone}
                                  </p>
                                  {element[0]?.milestone !== "Gate In" &&
                                    element[0]?.milestone !== "Delivered" && (
                                      <>
                                        <ClickAwayListener
                                          onClickAway={() => {
                                            return;
                                          }}
                                        >
                                          <div className="wfwesfdf absolute right-0 ml-[7px]">
                                            <HistoryTooltip
                                              title={
                                                <React.Fragment>
                                                  <p
                                                    style={{
                                                      fontSize: "12px",
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    {element[0]?.milestone +
                                                      " " +
                                                      (element[0]?.milestone?.includes(
                                                        "Departure"
                                                      )
                                                        ? element[0]?.origin
                                                        : element[0]?.station)}
                                                  </p>
                                                  
                                                  <h3 className="roadPlan">
                                                    Planned
                                                  </h3>
                                                  {element[0]
                                                    ?.flightSummary && (
                                                    <p
                                                      style={{
                                                        fontSize: "10px",
                                                      }}
                                                    >
                                                      {(() => {
                                                        const flightSummary =
                                                          element[0]
                                                            ?.flightSummary[0]
                                                            ?.flightId;
                                                        if (!flightSummary)
                                                          return "";

                                                        const etdValid =
                                                          flightSummary.etd &&
                                                          !isNaN(
                                                            new Date(
                                                              flightSummary.etd
                                                            ).getTime()
                                                          );
                                                        const etaValid =
                                                          flightSummary.eta &&
                                                          !isNaN(
                                                            new Date(
                                                              flightSummary.eta
                                                            ).getTime()
                                                          );

                                                        if (
                                                          etdValid &&
                                                          element[0]?.milestone?.includes(
                                                            "Departure"
                                                          )
                                                        ) {
                                                          return `${
                                                            flightSummary.flightNumber
                                                          } ${new Intl.DateTimeFormat(
                                                            "en-GB",
                                                            {
                                                              dateStyle:
                                                                "short",
                                                              timeStyle:
                                                                "short",
                                                            }
                                                          ).format(
                                                            new Date(
                                                              flightSummary.etd
                                                            )
                                                          )}`;
                                                        } else if (etaValid) {
                                                          return `${
                                                            flightSummary.flightNumber
                                                          } ${new Intl.DateTimeFormat(
                                                            "en-GB",
                                                            {
                                                              dateStyle:
                                                                "short",
                                                              timeStyle:
                                                                "short",
                                                            }
                                                          ).format(
                                                            new Date(
                                                              flightSummary.eta
                                                            )
                                                          )}`;
                                                        }
                                                        return "";
                                                      })()}
                                                    </p>
                                                  )}

                                                  {element[0]
                                                    ?.flightSummary && (
                                                    <div
                                                      style={{
                                                        fontSize: "10px",
                                                      }}
                                                    >
                                                      {element[0]?.flightSummary.map(
                                                        (
                                                          flight,
                                                          index
                                                        ) => (
                                                          <p key={index}>
                                                            <del>
                                                              {(() => {
                                                                const oldEtdValid =
                                                                  flight.oldEtd &&
                                                                  !isNaN(
                                                                    new Date(
                                                                      flight.oldEtd
                                                                    ).getTime()
                                                                  );
                                                                const oldEtaValid =
                                                                  flight.oldEta &&
                                                                  !isNaN(
                                                                    new Date(
                                                                      flight.oldEta
                                                                    ).getTime()
                                                                  );

                                                                if (
                                                                  oldEtdValid &&
                                                                  element[0]?.milestone?.includes(
                                                                    "Departure"
                                                                  )
                                                                ) {
                                                                  return `${
                                                                    flight
                                                                      .flightId
                                                                      .flightNumber
                                                                  } ${new Intl.DateTimeFormat(
                                                                    "en-GB",
                                                                    {
                                                                      dateStyle:
                                                                        "short",
                                                                      timeStyle:
                                                                        "short",
                                                                    }
                                                                  ).format(
                                                                    new Date(
                                                                      flight.oldEtd
                                                                    )
                                                                  )}`;
                                                                } else if (
                                                                  oldEtaValid
                                                                ) {
                                                                  return `${
                                                                    flight
                                                                      .flightId
                                                                      .flightNumber
                                                                  } ${new Intl.DateTimeFormat(
                                                                    "en-GB",
                                                                    {
                                                                      dateStyle:
                                                                        "short",
                                                                      timeStyle:
                                                                        "short",
                                                                    }
                                                                  ).format(
                                                                    new Date(
                                                                      flight.oldEta
                                                                    )
                                                                  )}`;
                                                                }
                                                                return "";
                                                              })()}
                                                            </del>
                                                          </p>
                                                        )
                                                      )}
                                                    </div>
                                                  )}

                                                  <p
                                                    style={{ fontSize: "12px" }}
                                                  >
                                                    Actual
                                                  </p>
                                                  <p
                                                    style={{ fontSize: "10px" }}
                                                  >
                                                    {element[0]?.status === 1
                                                      ? `${
                                                          element[0]
                                                            ?.flightNumber
                                                        } ${
                                                          element[0]?.date &&
                                                          !isNaN(
                                                            new Date(
                                                              element[0]?.date
                                                            ).getTime()
                                                          )
                                                            ? new Date(
                                                                element[0]?.date
                                                              ).toLocaleDateString(
                                                                "en-GB"
                                                              )
                                                            : "Invalid Date"
                                                        }`
                                                      : "Pending"}
                                                  </p>
                                                  <div className="mt-2 text-right">
                                                    <button
                                                      className="px-2 py-1 text-sm text-blue-500"
                                                      onClick={
                                                        handleHistoryClose
                                                      }
                                                    >
                                                      Close
                                                    </button>
                                                  </div>
                                                </React.Fragment>
                                              }
                                              open={index === dialogIndex}
                                              disableFocusListener
                                              disableHoverListener
                                              disableTouchListener
                                              placement="right"
                                            >
                                              <HistoryIcon
                                                style={{
                                                  fontSize: "18px",
                                                  cursor: "pointer",
                                                }}
                                                onClick={() =>
                                                  handleHistoryOpen(
                                                    index,
                                                    element[0].milestone,
                                                    element[0].flightNumber
                                                  )
                                                }
                                              />
                                            </HistoryTooltip>
                                          </div>
                                        </ClickAwayListener>
                                      </>
                                    )}
                                </div>
                              </div>
                              {(() => {
                                const mileStoneArray =
                                  element[0]?.milestone.split(" ");
                                return mileStoneArray[
                                  mileStoneArray.length - 1
                                ] === "Departure" ? (
                                  <h4 className="roadPlann">
                                    {element[0].origin}
                                  </h4>
                                ) : (
                                  <h4 className="roadPlann">
                                    {element[0].station}
                                  </h4>
                                );
                              })()}
                              <div className="raodDataMain">
                                {element?.map((milestone, ind) => (
                                  <>
                                    <div className="raodData">
                                      <figure className="flex justify-start">
                                        {milestone?.milestone ===
                                          "Origin Departure" ||
                                        milestone?.milestone ===
                                          "Trans Shipment Departure" ? (
                                          <Plane
                                            className={`${
                                              milestone?.status === 1
                                                ? "text-green-500"
                                                : "text-gray-500"
                                            }`}
                                          />
                                        ) : milestone?.milestone ===
                                            "Trans Shipment Arrival" ||
                                          milestone?.milestone === "Arrived" ||
                                          milestone?.milestone === "Arrival" ? (
                                          <Plane
                                            className={`${
                                              milestone?.status === 1
                                                ? "text-green-500"
                                                : "text-gray-500"
                                            }`}
                                          />
                                        ) : null}
                                      </figure>
                                      <small>
                                        {element[ind]?.milestone ===
                                          "Gate In" &&
                                        element[ind]?.status === 0 ? (
                                          "Details Awaited"
                                        ) : element[ind]?.status === 1 &&
                                          element[ind]?.date ? (
                                          <div>
                                            Date:{" "}
                                            {new Date(
                                              element[ind]?.date
                                            ).toLocaleString("en-IN", {
                                              timeZone: "Asia/Kolkata",
                                              year: "numeric",
                                              month: "2-digit",
                                              day: "2-digit",
                                            })}
                                            <br />
                                            {element[ind]?.milestone ===
                                              "Gate In" ||
                                            element[ind]?.milestone ===
                                              "Delivered" ? (
                                              <span>{`${element[ind].pieces}Pkts`}</span>
                                            ) : (
                                              <span>
                                                {`${element[ind].pieces}Pkts`} /{" "}
                                                {element[ind]?.flightNumber}
                                              </span>
                                            )}
                                          </div>
                                        ) : element[ind]?.old_etd ||
                                          element[ind]?.old_eta ? (
                                          <>
                                            {element[ind]?.old_etd && (
                                              <div>
                                                <del>
                                                  ETD:{" "}
                                                  {new Date(
                                                    element[ind]?.old_etd
                                                  ).toLocaleString("en-IN", {
                                                    timeZone: "Asia/Kolkata",
                                                    year: "numeric",
                                                    month: "2-digit",
                                                    day: "2-digit",
                                                  })}
                                                  <br />
                                                  <span>
                                                    {new Date(
                                                      element[ind]?.old_etd
                                                    ).toLocaleTimeString(
                                                      "en-IN",
                                                      {
                                                        timeZone:
                                                          "Asia/Kolkata",
                                                        hour: "2-digit",
                                                        minute: "2-digit",
                                                        hourCycle: "h23",
                                                      }
                                                    )}
                                                    {" / "}
                                                    {element[ind]?.flightNumber}
                                                  </span>
                                                </del>
                                              </div>
                                            )}
                                            {element[ind]?.old_eta && (
                                              <div>
                                                <del>
                                                  ETA:{" "}
                                                  {new Date(
                                                    element[ind]?.old_eta
                                                  ).toLocaleString("en-IN", {
                                                    timeZone: "Asia/Kolkata",
                                                    year: "numeric",
                                                    month: "2-digit",
                                                    day: "2-digit",
                                                  })}
                                                  <br />
                                                  <span>
                                                    {new Date(
                                                      element[ind]?.old_eta
                                                    ).toLocaleTimeString(
                                                      "en-IN",
                                                      {
                                                        timeZone:
                                                          "Asia/Kolkata",
                                                        hour: "2-digit",
                                                        minute: "2-digit",
                                                        hourCycle: "h23",
                                                      }
                                                    )}
                                                    {" / "}
                                                    {element[ind]?.flightNumber}
                                                  </span>
                                                </del>
                                              </div>
                                            )}
                                            {element[ind]?.etd ||
                                            element[ind]?.eta ? (
                                              <>
                                                {element[ind]?.etd && (
                                                  <div>
                                                    NEW ETD:{" "}
                                                    {new Date(
                                                      element[ind]?.etd
                                                    ).toLocaleString("en-IN", {
                                                      timeZone: "Asia/Kolkata",
                                                      year: "numeric",
                                                      month: "2-digit",
                                                      day: "2-digit",
                                                    })}
                                                    <br />
                                                    <span>
                                                      {new Date(
                                                        element[ind]?.etd
                                                      ).toLocaleTimeString(
                                                        "en-IN",
                                                        {
                                                          timeZone:
                                                            "Asia/Kolkata",
                                                          hour: "2-digit",
                                                          minute: "2-digit",
                                                          hourCycle: "h23",
                                                        }
                                                      )}
                                                      {" / "}
                                                      {
                                                        element[ind]
                                                          ?.flightNumber
                                                      }
                                                    </span>
                                                  </div>
                                                )}
                                                {element[ind]?.eta && (
                                                  <div>
                                                    NEW ETA:{" "}
                                                    {new Date(
                                                      element[ind]?.eta
                                                    ).toLocaleString("en-IN", {
                                                      timeZone: "Asia/Kolkata",
                                                      year: "numeric",
                                                      month: "2-digit",
                                                      day: "2-digit",
                                                    })}
                                                    <br />
                                                    <span>
                                                      {new Date(
                                                        element[ind]?.eta
                                                      ).toLocaleTimeString(
                                                        "en-IN",
                                                        {
                                                          timeZone:
                                                            "Asia/Kolkata",
                                                          hour: "2-digit",
                                                          minute: "2-digit",
                                                          hourCycle: "h23",
                                                        }
                                                      )}
                                                      {" / "}
                                                      {
                                                        element[ind]
                                                          ?.flightNumber
                                                      }
                                                    </span>
                                                  </div>
                                                )}
                                              </>
                                            ) : null}
                                          </>
                                        ) : (
                                          <>
                                            {element[ind]?.etd ||
                                            element[ind]?.eta ? (
                                              <>
                                                {element[ind]?.etd && (
                                                  <div>
                                                    ETD:{" "}
                                                    {new Date(
                                                      element[ind]?.etd
                                                    ).toLocaleString("en-IN", {
                                                      timeZone: "Asia/Kolkata",
                                                      year: "numeric",
                                                      month: "2-digit",
                                                      day: "2-digit",
                                                    })}
                                                    <br />
                                                    <span>
                                                      {new Date(
                                                        element[ind]?.etd
                                                      ).toLocaleTimeString(
                                                        "en-IN",
                                                        {
                                                          timeZone:
                                                            "Asia/Kolkata",
                                                          hour: "2-digit",
                                                          minute: "2-digit",
                                                          hourCycle: "h23",
                                                        }
                                                      )}
                                                      {" / "}
                                                      {
                                                        element[ind]
                                                          ?.flightNumber
                                                      }
                                                    </span>
                                                  </div>
                                                )}
                                                {element[ind]?.eta && (
                                                  <div>
                                                    ETA:{" "}
                                                    {new Date(
                                                      element[ind]?.eta
                                                    ).toLocaleString("en-IN", {
                                                      timeZone: "Asia/Kolkata",
                                                      year: "numeric",
                                                      month: "2-digit",
                                                      day: "2-digit",
                                                    })}
                                                    <br />
                                                    <span>
                                                      {new Date(
                                                        element[ind]?.eta
                                                      ).toLocaleTimeString(
                                                        "en-IN",
                                                        {
                                                          timeZone:
                                                            "Asia/Kolkata",
                                                          hour: "2-digit",
                                                          minute: "2-digit",
                                                          hourCycle: "h23",
                                                        }
                                                      )}
                                                      {" / "}
                                                      {
                                                        element[ind]
                                                          ?.flightNumber
                                                      }
                                                    </span>
                                                  </div>
                                                )}
                                              </>
                                            ) : (
                                              "Details Awaited"
                                            )}
                                          </>
                                        )}
                                      </small>
                                    </div>
                                  </>
                                ))}{" "}
                              </div>{" "}
                            </div>
                          </>
                        }
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div></div>
        </>
      </div>

      {showBox && (
        <Box
          sx={{
            position: "absolute",
            top: "140px", // Distance from the top
            right: "60px", // Aligns the box to the right edge of the screen
            height: "70px",
            width: { xs: "100%", sm: "200px" }, // Responsive width: 90% on small screens, 300px on larger screens
            backgroundColor: "lightgray",
            display: "flex",
            alignItems: "center",
            justifyContent: "end",
            zIndex: 9999,
            padding: "10px",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.5)",
          }}
        >
          {/* Read-only TextField showing the current URL */}
          <TextField
            value={publicUrl}
            InputProps={{
              readOnly: true,
              style: { fontSize: "12px" },
            }}
            fullWidth
          />

          {/* Copy Button */}
          <Button
            onClick={handleCopy}
            sx={{
              ml: 1,
              height: "100%",
              fontSize: "12px",
              padding: "10px",
              color: "white",
              backgroundColor: "black",
              borderRadius: "5px",
              cursor: "pointer",
            }}
          >
            Copy url
          </Button>
        </Box>
      )}
    </ThemeProvider>
  );
};

export default AwbTrackingPage;